import React from "react";
import { NavigateFunction } from "react-router-dom";
import { TabsContent } from "@altimateai/lego";
import { Loader } from "../../components/Loader";
import { EvalResult, ActiveRun } from "../../services/evals";
import { ActiveRunCard } from "./ActiveRunCard";
import { BatchRunsTable } from "./BatchRunsTable";
import { ServerPaginationControls, type ResultsPagination } from "./ServerPaginationControls";

interface RunsTabProps {
  resultsLoading: boolean;
  activeRun: ActiveRun | null;
  evalResults: EvalResult[] | undefined;
  expandedBatchRun: string | null;
  expandedBatchRunResultId: string | null;
  setExpandedBatchRun: (id: string | null) => void;
  setExpandedBatchRunResultId: (id: string | null) => void;
  setSelectedResult: (result: EvalResult) => void;
  navigate: NavigateFunction;
  resultsPagination?: ResultsPagination | null;
  setServerPage?: (page: number) => void;
}

export const RunsTab: React.FC<RunsTabProps> = ({
  resultsLoading,
  activeRun,
  evalResults,
  expandedBatchRun,
  expandedBatchRunResultId,
  setExpandedBatchRun,
  setExpandedBatchRunResultId,
  setSelectedResult,
  navigate,
  resultsPagination,
  setServerPage,
}) => {
  return (
    <TabsContent value="runs">
      {resultsLoading ? (
        <Loader label="Loading batch runs..." />
      ) : (
        <div key="runs-tab">
          {activeRun && (
            <ActiveRunCard
              activeRun={activeRun}
              setSelectedResult={setSelectedResult}
              navigate={navigate}
            />
          )}

          <BatchRunsTable
            evalResults={evalResults}
            activeRun={activeRun}
            expandedBatchRun={expandedBatchRun}
            expandedBatchRunResultId={expandedBatchRunResultId}
            setExpandedBatchRun={setExpandedBatchRun}
            setExpandedBatchRunResultId={setExpandedBatchRunResultId}
            navigate={navigate}
          />

          {resultsPagination && resultsPagination.totalPages > 1 && setServerPage && (
            <ServerPaginationControls pagination={resultsPagination} onPageChange={setServerPage} />
          )}
        </div>
      )}
    </TabsContent>
  );
};
